<ion-toast
  class="ion-toast-text-white"
  color="toast-failed"
  icon="cloud-offline-outline"
  message="No network connection"
  position="top"
  [isOpen]="ableToOpenOfflineToast()"
  [translucent]="true"
></ion-toast>
